import { render, staticRenderFns } from "./MyBatch.vue?vue&type=template&id=7983ec08&scoped=true&"
import script from "./MyBatch.vue?vue&type=script&lang=js&"
export * from "./MyBatch.vue?vue&type=script&lang=js&"
import style0 from "./MyBatch.vue?vue&type=style&index=0&id=7983ec08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7983ec08",
  null
  
)

export default component.exports